export default __webpack_public_path__ + "static/media/dealing-with-difficulties.4633bfdb.svg";